export default "__VITE_ASSET__666396c6__"